RivalIQ.apps.SocialChannelMatrix.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.MatrixListItem = Marionette.ItemView.extend({
        ui: {
            p: 'span'
        },
        modelEvents: {
            'userChangeRequest': 'onChangeRequest'
        },

        template: '#matrixListItemTemplate',

        className: function () {

            const me = this;
            me.setChannelStatus();
            return (App.isExport ? me.channelStatus.exportCssClass : me.channelStatus.cssClass);
        },

        initialize: function () {

            const me = this;
            const company = me.model.get('company');
            me.listenTo(company, 'change', me.onCompanyChanged);
        },

        onCompanyChanged: function () {

            const me = this;
            me.setChannelStatus();
            me.handleStateChange(me.channelStatus);
        },

        onRender: function () {

            const me = this;
            const model = me.model;
            const channel = model.get('channel');

            let showNotBusinessInstagramWarning = false;
            if (channel.source === RivalIQ.enums.sources.INSTAGRAM && !me.options.is1xux) {
                const companyRecord = me.model.get('company').getPrimaryRecord(channel.source);
                showNotBusinessInstagramWarning = !_.get(companyRecord, ['presence', 'instagram_business_account_id']);
            }

            const excludedCompanyIds = _.get(RivalIQ.state.landscape.get('auditSettings'), 'excludedCompanyIds', []);
            const isCompanyEditable = !_.includes(excludedCompanyIds, me.model.get('company').id);

            const iconContent = me.channelStatus.iconContent(me.options.is1xux, showNotBusinessInstagramWarning, isCompanyEditable);


            me.ui.p.html(iconContent);

            const popover = new App.views.MatrixListItemPopover({
                model: model,
                channelStatus: me.channelStatus,
                is1xux: me.options.is1xux,
                showNotBusinessInstagramWarning: showNotBusinessInstagramWarning
            });

            me.listenTo(popover, 'close', function () {

                me.ui.p.popover('hide');
            });

            me.ui.p.popover({
                trigger: 'hover',
                html: true,
                placement: 'left',
                // Setting the container to this element prevents the popover
                // from closing when the user mouses over to it
                container: me.ui.p,
                delay: {
                    hide: 70
                },
                title: function () {
                    return $('<span/>')
                        .addClass(`fa fa-color ${channel.fontIcon}`)
                        .add($('<span/>').text(` ${channel.name}`));
                },
                content: popover.render().el
            });
        },

        // TODO this flow could be a lot smoother if this view just rendered
        // the current state of the model...
        onChangeRequest: function () {

            const me = this;
            me.setChannelStatus();
            if ((me.model.get('hasUserEdit'))) {
                me.handleStateChange(App.enums.ChannelStatus.stillFinding);
                me.trigger('userEdit');
            } else {
                me.handleStateChange(App.enums.ChannelStatus.hasChangeRequest);
            }
        },

        /**
         * Sets the channel status
         */
        setChannelStatus: function () {

            const me = this;
            const model = me.model;
            const channel = model.get('channel');
            const company = model.get('company');

            // states are:
            // 6. disabled (channel is disabled)
            // 1. stillFinding (whole company is not finished)
            // 2. waitingForUserEdit (single channel is in the process of a company edit)
            // 4. present (handle was found)
            // 3. under review (no handle, but needs review and not in the 1xux)
            // 5. notPresent none of the above

            if (company.stillFinding()) {
                me.channelStatus = App.enums.ChannelStatus.stillFinding;
            } else if (company.stillWaitingForUserEdit(channel.source)) {
                me.channelStatus = App.enums.ChannelStatus.hasChangeRequest;
            } else if (company.getPrimaryRecord(channel.source)) {
                me.channelStatus = App.enums.ChannelStatus.present;
            } else if (company.isUnderReview(channel.source) && !company.isUserDeleted(channel.source) && !me.options.is1xux) {
                me.channelStatus = App.enums.ChannelStatus.underReview;
            } else {
                me.channelStatus = App.enums.ChannelStatus.notPresent;
            }
        },

        /**
         * Set item to the "new look", and rerender.
         * @param {App.enums.ChannelStatus} newChannelStatus
         */
        handleStateChange: function (newChannelStatus) {

            const me = this;
            me.channelStatus = newChannelStatus;
            me.$el.removeClass().addClass(newChannelStatus.cssClass);
            me.render();
        }

    });

});
